// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/" + ({"1966": "react","235": "styled-components","3271": "socketio","3389": "apollo","7835": "steelhouse-libs","8016": "common","9841": "utilities","9844": "antd",}[chunkId] || chunkId) + ".chunk.js"
}